/**
 * 阿里云 CDN 图片处理：按指定宽度等比缩放。
 * 文档：https://help.aliyun.com/zh/cdn/user-guide/image-processing-operation-method
 *
 * 若链接已包含阿里云图片处理参数（image_process），则原样返回，不再重复追加。
 */
export const resizeImage = (url?: string | null, width = 200): string => {
  if (!url) return url ?? ""
  if (url.includes("image_process=")) return url
  const sep = url.includes("?") ? "&" : "?"
  return `${url}${sep}image_process=resize,w_${width}`
}

/** URL 安全 Base64，给图片处理的 text 参数用 */
const urlSafeBase64 = (value: string) => {
  const bytes = new TextEncoder().encode(value)
  let binary = ""
  bytes.forEach(byte => {
    binary += String.fromCharCode(byte)
  })
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "")
}

/**
 * 故事详情只有原图。非会员下载时把水印加在地址上：
 * OSS 用 x-oss-process，CDN 用 image_process。
 */
export const watermarkImage = (url?: string | null): string => {
  if (!url) return ""
  if (url.includes("x-oss-process=") || url.includes("image_process=")) return url
  const text = urlSafeBase64("HiWaifu")
  const mark = `watermark,text_${text},color_FFFFFF,size_64,t_90,g_se,x_32,y_32`
  const sep = url.includes("?") ? "&" : "?"
  let host = ""
  try {
    host = new URL(url).host
  } catch { /* 相对地址按 CDN 参数处理 */ }
  if (/aliyuncs\.com|oss-accelerate/i.test(host)) {
    return `${url}${sep}x-oss-process=image/${mark},shadow_50`
  }
  return `${url}${sep}image_process=${mark}`
}
